import type { TransactionSource, TransactionStatus } from "api/responses";

/**
 * Identifies each type of filter we support.
 * See Vyne.Payments.BusinessLogic.Queries.PaidReportDetailStatus.
 */
export type PaymentsActivityStatusFilterType = TransactionStatus | "RefundAll";

/**
 * The list of Transaction statuses that can be filtered by.
 *
 * Also serves as the initial filter, because we display all statuses by default.
 */
export const initialStatuses: PaymentsActivityStatusFilterType[] = ["RefundAll", "RefundPartial", "Paid"];

export const transactionStatusToText: Record<PaymentsActivityStatusFilterType, string> = {
    RefundAll: "Refund",
    RefundFull: "Refund",
    RefundPartial: "Partial Refund",
    Paid: "Paid",
};

/**
 * The list of Transaction sources that can be filtered by.
 *
 * Also serves as the initial filter, because we display all sources by default.
 */
export const initialSources: TransactionSource[] = [
    "None",
    "Dashboard",
    "Email",
    "SMS",
    "Statement",
    "DashboardLink",
    "BillPay",
    "DashboardInsurance",
];

export const transactionSourceValues: Record<TransactionSource, string> = {
    None: "Unknown",
    Dashboard: "Take a Payment",
    Email: "Email",
    SMS: "SMS",
    Statement: "Paper Statement",
    API: "Vyne Trellis",
    DashboardLink: "Dashboard Link",
    BillPay: "Bill Pay",
    DashboardInsurance: "Insurance",
};

export function handleToggleStatus(
    currentStatuses: PaymentsActivityStatusFilterType[],
    status: PaymentsActivityStatusFilterType,
    enabled: boolean,
) {
    let newStatuses = [...currentStatuses];

    const index = currentStatuses.indexOf(status);

    // if enabled and not already included
    if (enabled && index < 0) {
        newStatuses.push(status);
    } else if (!enabled && index >= 0) {
        newStatuses.splice(index, 1);
    }

    // handle all statuses being toggled off
    if (newStatuses.length === 0) {
        // set all to true
        newStatuses = [...initialStatuses];
    }

    return newStatuses;
}

export function handleToggleSource(currentSources: TransactionSource[], source: TransactionSource, enabled: boolean) {
    let newSources = [...currentSources];

    const index = currentSources.indexOf(source);
    if (enabled && index < 0) {
        newSources.push(source);
    } else if (!enabled && index >= 0) {
        newSources.splice(index, 1);
    }

    // handle all sources being toggled off
    if (newSources.length === 0) {
        // set all to true
        newSources = [...initialSources];
    }

    return newSources;
}
